export const name = 'debug' as const
export const TbDebugSymbol = Symbol('tbDebug')
